import { handleJSON } from "@synbioz/ajax";
import qs from "qs";
import { normalizePortfolio } from "@delegate/auth-helper";

const path = "/api/v4/admin/portfolios";
let mockData;

async function loadMockData() {
  return await import("../portfolios");
}

/**
 * @param {Function} authFetch
 * @param {Number}   pageSize
 * @param {String}   url
 * @param {Object}   payload
 * @param {Number}   page          Internal, do not use
 * @param {Array}    recursiveData Internal, do not use
 *
 * @return {Promise} Promise resolving to aggregated data as an object
 */
function fetchAllPagesFromAPI(
  authFetch,
  pageSize,
  url,
  payload = undefined,
  page = 1,
  recursiveData = []
) {
  let totalPages;

  return authFetch(url + "?" + qs.stringify({ ...payload, page }))
    .then(handleJSON)
    .then(data => {
      totalPages = parseInt(data.meta.total_pages);
      recursiveData = [...recursiveData, ...data.portfolios];

      if (
        (!isNaN(totalPages) && page >= totalPages)
        || data.portfolios.length < pageSize
      ) {
        return recursiveData;
      }

      return fetchAllPagesFromAPI(authFetch, pageSize, url, payload, page + 1, recursiveData);
    });
}

const mockFunctions = {
  getPortfolio: portfolioUID => ({
    portfolio: normalizePortfolio(mockData.portfolios.find(({ uid }) => uid === portfolioUID))
  }),

  searchPortfolio: () => mockData.portfolios.map(normalizePortfolio)
};

export default function getAPIClient(apiHost, authFetch) {
  // In development, use the functions above, lazily loading mock data the first time any of them is called
  if (!apiHost) {
    return Object.keys(mockFunctions).reduce((functions, key) => ({
      ...functions,
      [key]: async (...args) => {
        mockData = mockData || await loadMockData(); // eslint-disable-line require-atomic-updates

        return mockFunctions[key](...args);
      }
    }), {});
  }

  return {
    getPortfolio(portfolioUID) {
      return authFetch(apiHost + path + `/${portfolioUID}`)
        .then(handleJSON)
        .then(json => normalizePortfolio(json.portfolio));
    },

    searchPortfolio(query, pageSize = 50) {
      return fetchAllPagesFromAPI(authFetch, pageSize, apiHost + path, { "filter[full_name]": query })
        .then(json => json.map(normalizePortfolio));
    }
  };
}
